import { useNavigate, useParams } from "react-router-dom";
import ChevronLeftIcon from "../../assets/svg/ChevronLeftIcon";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "@lib/dayjs";
import { fetchReceiptUserDetails } from "../../store/actions/payment.action";

const TransactionUserDetailPage = () => {
  const navigate = useNavigate();
  const { userId, jobId } = useParams();
  const dispatch = useDispatch();
  const { receiptUserDetails, loading: reduxLoading } = useSelector(
    (state) => state.payment
  );
  const initialized = useRef(false);

  // Helper function to get job type text
  const getJobTypeText = (jobType) => {
    switch (jobType) {
      case 1:
        return "Full Time";
      case 2:
        return "Contract";
      case 3:
        return "Part Time";
      case 4:
        return "Internship";
      default:
        return "NA";
    }
  };

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;
    console.log("userId", userId);
    console.log("jobId", jobId);
    dispatch(fetchReceiptUserDetails(userId, jobId));
  }, [userId, jobId]);
  return (
    <div className="w-full h-full bg-white rounded-xl">
      <div className="flex items-center justify-between p-4 relative">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center mb-3 no-print"
        >
          <ChevronLeftIcon className={"w-4 h-4"} fill="#4d4d4d" />
          <label className="text-[10px] font-medium text-charcoal cursor-pointer font-montserrat">
            Back to listing
          </label>
        </button>
      </div>
      {reduxLoading ? (
        <div className="gap-2.5 flex flex-col p-6">
          {Array.from({ length: 10 }, (x, i) => i).map((key) => (
            <div key={key} className="flex justify-between">
              <div
                style={{
                  borderWidth: 1,
                }}
                className="flex rounded-lg w-full pl-3 pr-8 py-4 gap-1.5"
              >
                <div className="h-3 rounded bg-gray-200 w-1/4"></div>
                <div className="h-3 rounded bg-gray-200 w-1/4"></div>
                <div className="h-3 rounded bg-gray-200 w-1/4"></div>
              </div>
            </div>
          ))}
        </div>
      ) : receiptUserDetails !== undefined &&
        Object.keys(receiptUserDetails).length !== 0 ? (
        <div className="flex px-7 ">
          {/* right side referral/candidate details */}
          <div className="border-2 border-[#ECECEC] rounded-sm p-6 flex flex-col items-center gap-y-5 w-2/5">
            <p className="text-charcoal text-sm font-bold mb-5">
              {receiptUserDetails?.userDetails?.userType == 4
                ? "Referral Details"
                : "Candidate Details"}
            </p>
            <p className="font-medium text-xs">
              {receiptUserDetails?.userDetails?.refNo}
            </p>
            <div className="flex rounded-full h-[150px] w-[150px] bg-[#E1E0E0] items-center justify-center max-md:h-36 max-md:w-36">
              {receiptUserDetails?.userDetails?.profilePic ? (
                <img
                  src={receiptUserDetails?.userDetails?.profilePic}
                  alt="profileImg"
                />
              ) : (
                <span className="font-montserrat text-white font-semibold text-6xl">
                  {receiptUserDetails?.userDetails?.firstName
                    ?.charAt(0)
                    .toUpperCase()}
                  {receiptUserDetails?.userDetails?.lastName
                    ?.charAt(0)
                    .toUpperCase()}
                </span>
              )}
            </div>
            <p className="text-sm font-bold">
              {receiptUserDetails?.userDetails?.firstName}{" "}
              {receiptUserDetails?.userDetails?.lastName}
            </p>
            <div className="flex gap-x-2 text-xs">
              <p className=" font-semibold">username:</p>
              <p className="text-gray-500 text-[13px]">
                {receiptUserDetails?.userDetails?.userName}
              </p>
            </div>
            <a href="#" className="text-[13px] text-charcoal pb-10">
              https://comtracked/profile/
              {receiptUserDetails?.userDetails?.userName}
            </a>
          </div>
          {/* left side job details*/}
          <div className="ml-10 flex flex-col gap-y-3 w-full text-sm">
            <p className="border-b-2 pb-3 text-charcoal text-sm font-bold">
              Job Details
            </p>
            <div className="flex gap-x-2 items-center">
              <p className=" font-semibold">Job Title:</p>
              <p>{receiptUserDetails?.jobDetails?.title}</p>
            </div>
            <div className="flex gap-x-2 items-center">
              <p className=" font-semibold">Reference:</p>
              <p>{receiptUserDetails?.jobDetails?.refNo}</p>
            </div>
            <div className="flex gap-x-2 items-center">
              <p className="font-semibold">Location:</p>
              <p>{receiptUserDetails?.jobDetails?.location}</p>
            </div>
            <div className="flex gap-x-2 items-center">
              <p className="font-semibold">Industry Type:</p>
              <p>{receiptUserDetails?.jobDetails?.industryType}</p>
            </div>
            <div className="flex gap-x-2 items-center">
              <p className="font-semibold">Job Type:</p>
              <p>{getJobTypeText(receiptUserDetails?.jobDetails?.jobType)}</p>
            </div>
            <div className="flex gap-x-2 items-center">
              <p className="font-semibold">Salary Range:</p>
              <p>
                £{receiptUserDetails?.jobDetails?.salary?.min}-£
                {receiptUserDetails?.jobDetails?.salary?.max}
              </p>
            </div>
            <div className="flex gap-x-2 items-center">
              <p className="font-semibold">Published Date:</p>
              <p>
                {receiptUserDetails?.jobDetails?.publishedDate
                  ? dayjs(
                      receiptUserDetails?.jobDetails?.publishedDate
                    ).format("Do MMMM, YYYY")
                  : "NA"}
              </p>
            </div>
            <div className="flex gap-x-2 items-center">
              <p className="font-semibold">Referral fee:</p>
              <p>£{receiptUserDetails?.jobDetails?.referralAmount}</p>
            </div>
            <button
              className="rounded px-4 py-2 bg-secondary text-white font-semibold w-1/3 mt-5"
              onClick={() =>
                navigate(
                  `/job/${receiptUserDetails?.jobDetails?._id.toString()}/job-details`
                )
              }
            >
              View Job Details
            </button>
          </div>
        </div>
      ) : (
        <>
          <h1 className="flex items-center justify-center">
            Details not found
          </h1>
        </>
      )}
    </div>
  );
};

export default TransactionUserDetailPage;
